import { configureStore } from "@reduxjs/toolkit";
import userReducer from "./features/userSlice";
import { computeCapacityApi } from "./api/computeCapacityApi";
import { bomApi } from "./api/bomApi";
import { userApi } from "./api/userApi";
import { dashboardApi } from "./api/dashboardApi";
import { customerApi } from "./api/customerApi";
import { orderApi } from "./api/orderApi";
import { gpuApi } from "./api/gpuApi";
import { handleExpiredToken } from "./middlewares/handleExpiredToken";

export const store = configureStore({
  reducer: {
    user: userReducer,
    [computeCapacityApi.reducerPath]: computeCapacityApi.reducer,
    [bomApi.reducerPath]: bomApi.reducer,
    [userApi.reducerPath]: userApi.reducer,
    [dashboardApi.reducerPath]: dashboardApi.reducer,
    [customerApi.reducerPath]: customerApi.reducer,
    [orderApi.reducerPath]: orderApi.reducer,
    [gpuApi.reducerPath]: gpuApi.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware()
      .concat(computeCapacityApi.middleware)
      .concat(bomApi.middleware)
      .concat(userApi.middleware)
      .concat(dashboardApi.middleware)
      .concat(customerApi.middleware)
      .concat(orderApi.middleware)
      .concat(gpuApi.middleware)
      .concat(handleExpiredToken),
});

export default store;
